import axios from 'axios'

import { NEWSLETTER as ENDPOINT } from '../common/endpoints'
import { success, error } from './toast-notifications'
import { t } from './i18n'

const newsletter = document.getElementById('footer-newsletter-form')

const getToken = (evt) => {
	evt.preventDefault()
	grecaptcha.ready(function() {
		grecaptcha.execute('6Ldtk0gfAAAAACPWMoSiKjmoEZ68JbjcdCT9Vqo-', {action: 'submit'}).then(function(token) {

			const tokenField = document.querySelector('.g-recaptcha-token')
			tokenField.value = token
			newsletterSubscribe(evt)

		})
	})
}


const newsletterSubscribe = async (e) => {
	
	var token
	const email = document.getElementById('footer-newsletter-email')
	const tokenField = document.querySelector('.g-recaptcha-token')
	
	token = tokenField.value

 	try {
		// email newsletter
 		const res = await axios.post(ENDPOINT, {
			data: {
				lang: window.motostorm.lang,
				token: token,
				email: email.value
			}		
		})

		success(t('newsletter-subscribe-success'))
		if(1==2){
			warning(t('newsletter-subscribe-warning'))
		}
	} catch (err) {
		console.log(err)
		error(t('newsletter-subscribe-error'))
	}
	
}


const setupNewsletterForm = (thisform) => {
	thisform.addEventListener('submit', getToken)
}

// init
if(newsletter) {
	setupNewsletterForm(newsletter)
}